/* eslint no-console:0 */
import '../../dropdown';
import '../../flash_msg';
import '../../job_favorite';
import '../../cookie_favorite_button';
import FloatingMenu from '../../floating_menu';
import JobsFloatingMenu from '../../jobs_floating_menu';
import { searchConditionChange } from './search_condition_change';
import { initFloatingChat } from '@/entrypoints/floating_chat';

document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('ver') && urlParams.get('ver') === 'issue_4427') {
    new JobsFloatingMenu(800);
  } else {
    new FloatingMenu(800);
  }

  // 検索条件変更のためのJSを呼ぶ
  searchConditionChange();
  initFloatingChat();

  if (urlParams.has('ver') && urlParams.get('ver') === 'issue_4536') {
    const items = document.querySelectorAll('.p-job-change-banner__item');
    items.forEach((element, index) => {
      setTimeout(() => {
        element.classList.add('shadow');
      }, 100 * (index + 1)); // 各要素に0.1秒ずつ遅延をつける
    });
  }
});
